import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import type { ReactElement } from 'react'

import AppLogo from '~/components/AppLogo'
import TableVariation from '~/components/TableVariation'
import { useSearchParamsContext } from '~/providers/SearchParams'
import { appKeyDeviceTypeToString } from '~/utils/application'
import { getNumberWithSpaces } from '~/utils/number'

import './styles.scss'

interface Props {
  appIcon: string
  appId: string
  appKey: string
  appName: string
  deviceType: string
  mau: number
  mauDiff?: number
  mauProgression?: number
  platform: string
  type: 'small' | 'normal'
}

const TableRow = ({
  appIcon,
  appId,
  appKey,
  appName,
  deviceType,
  mau,
  mauDiff,
  mauProgression,
  platform,
  type,
}: Props): ReactElement => {
  const navigate = useNavigate()

  const { dispatchToSearchParams } = useSearchParamsContext()

  const tableRowClasses = classNames('table-row-component', { clickable: appId.length, small: type === 'small' })

  const handleRedirectToSummary = () => {
    if (appKey.length && deviceType.length) {
      const application = appKeyDeviceTypeToString(appKey, deviceType)
      dispatchToSearchParams({ type: 'update', value: { app: application } })
      navigate(`/summary?app=${application}`)
    }
  }

  return (
    <div className={tableRowClasses} onClick={handleRedirectToSummary}>
      <div className="row-data-wrapper">
        <div className="app-identity">
          <AppLogo appLogoUrl={appIcon} appPlatform={platform} size="small" />
          <div className="app-name-container">
            <div className="app-name">{appName}</div>
            {mauDiff && <div className="mau">{getNumberWithSpaces(mau)} MAU</div>}
          </div>
        </div>
        <div className="evolution">
          <div className="value-wrapper">
            <div className="mau-value">
              {mauDiff
                ? mauDiff > 0
                  ? '+' + getNumberWithSpaces(mauDiff)
                  : getNumberWithSpaces(mauDiff)
                : getNumberWithSpaces(mau)}
            </div>{' '}
            <div className="mau-mention">MAU</div>
          </div>
          {mauProgression && <TableVariation value={mauProgression} />}
        </div>
      </div>
    </div>
  )
}

export default TableRow
